import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntroSection() {
  const benefits = ['Control real', 'Mejor respuesta sexual', 'Cero ansiedad', 'Seguridad recuperada'];
  return <section className="relative w-full bg-black py-10 md:py-14 overflow-hidden" data-id="element-386">
      <div className="absolute inset-0 z-0" data-id="element-387">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-red-700/20 blur-[140px]" data-id="element-388" />
      </div>

      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-[#0a0a0a] to-transparent z-10" data-id="element-389" />
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" data-id="element-390" />

      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-px bg-gradient-to-r from-transparent via-red-600 to-transparent z-20" data-id="element-391" />

      <div className="relative z-20 max-w-4xl mx-auto px-6 text-center" data-id="element-392">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-393">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-394">
            <div className="w-10 h-px bg-red-600" data-id="element-395" />
            <span className="text-red-500 text-xs uppercase tracking-[0.3em] font-bold" data-id="element-396">
              💡 La solución
            </span>
            <div className="w-10 h-px bg-red-600" data-id="element-397" />
          </div>

          <div className="relative mb-8" data-id="element-398">
            <div className="absolute inset-0 blur-3xl bg-red-600/25 -z-10" data-id="element-399" />
            <h2 className="font-display text-3xl md:text-5xl uppercase leading-[1.05] tracking-tight" data-id="element-400">
              <span className="block text-white drop-shadow-[0_0_20px_rgba(220,38,38,0.5)]" data-id="element-401">
                Aquí entra
              </span>
              <span className="block mt-1 text-transparent bg-clip-text bg-gradient-to-b from-red-500 to-red-700 drop-shadow-[0_0_25px_rgba(220,38,38,0.8)]" data-id="element-402">
                Control Total
              </span>
              <span className="block mt-1 text-white text-lg md:text-2xl tracking-wider" data-id="element-403">
                — Reset Masculino —
              </span>
            </h2>
          </div>

          {/* Benefits as inline pills */}
          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8" data-id="element-404">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08,
            duration: 0.4
          }} className="bg-[#0a0a0a]/80 backdrop-blur-sm border border-red-900/40 px-4 py-2 rounded-full shadow-[0_0_15px_rgba(220,38,38,0.08)]" data-id="element-405">
                <span className="text-sm md:text-base text-white font-semibold flex items-center gap-2" data-id="element-406">
                  <span className="text-red-500" data-id="element-407">✔</span> {benefit}
                </span>
              </motion.div>)}
          </div>

          <div className="relative bg-gradient-to-b from-[#0a0a0a] to-black border border-red-900/50 px-6 py-5 rounded-lg shadow-[0_0_40px_rgba(220,38,38,0.12)] max-w-2xl mx-auto overflow-hidden" data-id="element-408">
            <span className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-red-600" data-id="element-409" />
            <span className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-red-600" data-id="element-410" />
            <span className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-red-600" data-id="element-411" />
            <span className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-red-600" data-id="element-412" />

            <p className="md:text-lg text-gray-300 text-[16px]" data-id="element-413">
              <span className="text-red-500 font-bold" data-id="element-414">🧩 No es un ebook.</span>{' '}
              Es un{' '}
              <span className="text-white font-bold" data-id="element-415">sistema de 6 niveles</span>{' '}
              + 6 bonos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}